import { http } from "@/core/api/";
import requestLocation from "@/modules/common/location.api";

import DISCIPLINE_TYPES from "@/utils/constants/disciplineTypes";
import codeService from "@/modules/common/code.api";
import categories from "@/utils/constants/categoriesFlag";
import serviceTypes from "@/utils/constants/service-types";

const apiBaseUrl = "/api/studentevaluation";

export default {
  /**
   * Get Student Request Evaluations
   */
  async getRequests(filters) {
    return await http.post(`${apiBaseUrl}/requests`, filters);
  },

  async getAvailableEvaluations(studentSieId) {
    return await http.get(
      `${apiBaseUrl}/getevaluationsavailabletocoordinate/${studentSieId}`
    );
  },
  async getAvailableDocument(studentSieId, disciplineTypeId) {
    return await http.get(
      `${apiBaseUrl}/availabledocumentbackup/${studentSieId}`,
      {
        params: { disciplineTypeId }
      }
    );
  },
  //Get Filters basic and Advanced
  async getFilters(isAdvanced) {
    let requests;
    if (isAdvanced) {
      requests = [
        this.getServices(),
        this.getEvaluations({
          serviceTypeIds: [
            serviceTypes.EvaluacionInicial,
            serviceTypes.EvaluacionAdicional
          ],
          categories: [categories.validForAppointment],
          disciplineIds: [
            DISCIPLINE_TYPES.AsistenciaTecnologia,
            DISCIPLINE_TYPES.AutismoInfantilAd,
            DISCIPLINE_TYPES.AutismoInfantilIn
          ],
          modules: []
        }),
        this.getStatuses()
        //requestLocation.getCenters({ AcademicYearId: selectedAcademicYear.id }),
        //Esto deberia cambiar en base al orden (Y crear los metodos pertinentes)
        // requestLocation.getRegions({ AcademicYearId: selectedAcademicYear.id }),
        // requestLocation.getMunicipalities({ AcademicYearId: selectedAcademicYear.id }),
        // requestLocation.getMunicipalities({ AcademicYearId: selectedAcademicYear.id }),
      ];
    } else {
      requests = [this.getAcademicYear()];
    }

    return Promise.all(requests);
  },
  async getCenters(params) {
    return await requestLocation.getCenters(params);
  },
  async getRegions(params) {
    return await requestLocation.getRegions(params);
  },
  async getMunicipalities(params) {
    return await requestLocation.getMunicipalities(params);
  },
  async getSchools(params) {
    return await requestLocation.getSchools(params);
  },
  async getAcademicYear() {
    const { status, data: response } = await http.get("/api/academicyears");
    return status !== 200 ? {} : response;
  },
  async getServices() {
    const { status, data: response } = await http.get(
      "api/code/getrequestmanagementevaluationtypes"
    );
    return status !== 200 ? {} : response;
  },
  async getEvaluations(params) {
    return codeService.getDisciplineTypes(params);
  },
  async getStatuses() {
    const { status, data: response } = await http.get(
      "api/code/referralstatus"
    );
    return status !== 200 ? {} : response;
  },
  async getStudentEvaluationHistoryStatus(studentReferralId) {
    return await http.get(
      `${apiBaseUrl}/requeststatushistory/${studentReferralId}`
    );
  },
  async updateReferralStatusReason(param) {
    return await http.put(`${apiBaseUrl}/updateReferralStatusReason/`, param);
  }
};
